import * as types from 'store/modules/hres81x/mutation-types'
import hres81x from 'api/hres81x'
import swal from 'sweetalert'
import hres81xLabels from 'assets/labels/hres81x'
import env from 'src/../env.js'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    labels: hres81xLabels,
    index: {
      block_index: {},
      block: {},
      block1: {},
      block2: {},
      block3: {},
      msg_error: '...'
    },
    flgProcess: true,
    flgLoginSuccess: false,
    numperiod: '1,2,3,4,5,6,7,8,9,10',
    lastNumperiod: '1'
  },
  getters: {
    [types.GET_HRES81X_DETAIL_DISP] (state) {
      return state.indexDetail
    },
    [types.GET_HRES81X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES81X_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES81X_NUMPERIOD] (state) {
      return state.numperiod
    },
    [types.GET_HRES81X_LAST_NUMPERIOD] (state) {
      return state.lastNumperiod
    },
    [types.GET_HRES81X_FLG_PROCESS] (state) {
      return state.flgProcess
    },
    [types.GET_HRES81X_FLG_LOGIN_SUCCESS] (state) {
      return state.flgLoginSuccess
    }
  },
  mutations: {
    [types.SET_HRES81X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRES81X_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES81X_NUMPERIOD] (state, data) {
      state.numperiod = data
    },
    [types.SET_HRES81X_LAST_NUMPERIOD] (state, data) {
      state.lastNumperiod = data
    },
    [types.SET_HRES81X_FLG_PROCESS] (state, flgProcess) {
      state.flgProcess = flgProcess
    },
    [types.SET_HRES81X_FLG_LOGIN_SUCCESS] (state, flgLoginSuccess) {
      state.flgLoginSuccess = flgLoginSuccess
    }
  },
  actions: {
    [types.RECEIVED_COLUMNS_LABELS] ({ commit }) {
      hres81x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES81X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES81X_INDEX] ({ commit }, searchParams) {
      commit(types.SET_HRES81X_FLG_PROCESS, true)
      hres81x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES81X_INDEX, data)
          commit(types.SET_HRES81X_FLG_PROCESS, false)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
          commit(types.SET_HRES81X_FLG_PROCESS, false)
        })
    },
    [types.RECEIVED_HRES81X_NUMPERIOD] ({ commit }, searchParams) {
      commit(types.SET_HRES81X_NUMPERIOD, '1')
      hres81x.getNumperiod(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES81X_NUMPERIOD, data.numperiod)
          commit(types.SET_HRES81X_LAST_NUMPERIOD, data.last_numperiod)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
          commit(types.SET_HRES81X_NUMPERIOD, '1,2,3,4,5,6,7,8,9,10')
          commit(types.SET_HRES81X_LAST_NUMPERIOD, '1')
        })
    },
    [types.POST_HRES81X_PRINT] ({ commit, dispatch }, { sendParams }) {
      swal({
        title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false
      }, function () {
        window.onkeydown = null; window.onfocus = null; swal('')
      })
      hres81x.postPrint({ sendParams })
        .then((response) => {
          const data = response.request.response
          swal.close()
          let url = window.localStorage.getItem(env.site + '_baseURL') + data
          window.open(url, '_blank')
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.POST_HRES81X_LOGIN] ({ commit, dispatch }, { sendParams }) {
      swal({
        title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false
      }, function () {
        window.onkeydown = null; window.onfocus = null; swal('')
      })
      commit(types.SET_HRES81X_FLG_LOGIN_SUCCESS, false)
      hres81x.postLogin({ sendParams })
        .then((response) => {
          const data = response.request.response
          if (typeof data !== 'undefined') {
            if (data.toLowerCase().indexOf('error') === -1) {
              swal.close()
              commit(types.SET_HRES81X_FLG_LOGIN_SUCCESS, true)
            } else {
              swal({
                title: '', text: '!!! Invalid Password !!!', html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            }
          } else {
            swal({
              title: '', text: '!!! Error while authenicate !!!', html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres81x/index.js